import liveLogoSrc from '../assets/rnr_logo_live.png';
import uatLogoSrc from '../assets/rnr_logo_uat.png';
import stagingLogoSrc from '../assets/rnr_logo_staging.png';
import fawLogoSrc from '../assets/faw_logo.png';

const hostname = window.location.hostname.toLowerCase();
export const isFaw = hostname === 'faw.localhost'
  || hostname === 'faw-app.rnresponse.co.za'
  || hostname.includes('v2-pretty-faw-mobile');
const isUat = import.meta.env.MODE === 'uat'
  || hostname.includes('uat')
  || hostname.includes('localhost');
const isStaging = import.meta.env.MODE === 'staging'
  || hostname.includes('staging');

export const branding = isFaw
  ? {
      appName: 'FAW Mobile',
      logoAlt: 'FAW Logo',
      logoSrc: fawLogoSrc,
      favicon: '/faw_logo.png',
      manifest: '/manifest-faw.webmanifest',
      primaryColor: '#001F4B',
      mobileUrl: 'https://faw-app.rnresponse.co.za',
    }
  : isUat
    ? {
        appName: 'RNR Mobile',
        logoAlt: 'RNR Logo',
        logoSrc: uatLogoSrc,
        favicon: '/rnr_logo_uat.png',
        manifest: null,
        primaryColor: '#55C259',
        mobileUrl: 'https://mobile.rnresponse.co.za',
      }
    : isStaging
      ? {
          appName: 'RNR Mobile',
          logoAlt: 'RNR Logo',
          logoSrc: stagingLogoSrc,
          favicon: '/rnr_logo_staging.png',
          manifest: null,
          primaryColor: '#3568BD',
          mobileUrl: 'https://mobile.rnresponse.co.za',
        }
      : {
          appName: 'RNR Mobile',
          logoAlt: 'RNR Logo',
          logoSrc: liveLogoSrc,
          favicon: '/rnr_logo_live.png',
          manifest: null,
          primaryColor: '#E3413A',
          mobileUrl: 'https://mobile.rnresponse.co.za',
        };
